import React, { FC } from 'react'
import {
  Box,
  Container,
  Flex,
  Heading,
  Text,
} from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { IllustrationBubbleError } from '@moonpig/launchpad-assets'
import { useFlag } from '@moonpig/web-core-eppo/browser'
import { useLocaleText } from '../locale'

const StyledIncidentBanner = styled.div`
  width: 100%;
  ${s({
    bgcolor: 'colorBackgroundWarning',
    py: 4,
    px: { xs: 6, md: '102px' },
  })}
`

export const IncidentBanner: FC = () => {
  const t = useLocaleText()

  const isIncidentBannerEnabled = useFlag('web-platform-incident-banner', {
    fallback: false,
  })

  if (!isIncidentBannerEnabled) {
    return null
  }

  return (
    <StyledIncidentBanner>
      <Container limitWidth padding={8}>
        <Flex
          flexDirection={{ xs: 'column', md: 'row' }}
          alignItems={{ xs: 'flex-start', md: 'center' }}
          gap={6}
        >
          <Box display={{ xs: 'none', md: 'block' }}>
            <IllustrationBubbleError height="38px" width="38px" />
          </Box>

          <Flex flexDirection="column" justifyContent="center">
            <Heading level="h6" my={0} color="colorFeedbackError">
              {t('incident_banner.heading')}
            </Heading>
            <Text typography="typeBodyCaption">
              {t('incident_banner.message')}
            </Text>
          </Flex>
        </Flex>
      </Container>
    </StyledIncidentBanner>
  )
}
